<div class="container coffee-container">
  <div class="coffee-container-overlay"></div>
  <div class="row" *ngIf="!isSuccess && !errorMessage">
    <div class="col"></div>
    <div class="col-12">
      <form [formGroup]="makeCoffeeForm" (ngSubmit)="makeCoffeeFormSubmit()">
        <div class="form-row justify-content-center">
          <div class="col-md-5 mb-3">
            <input type="text" class="form-control" formControlName="coffeeCode" id="coffeeCode"
                   placeholder="Enter user coffee code here">
          </div>
        </div>
        <div class="form-row justify-content-center">
          <div class="col-auto">
            <button type="submit" class="btn primary-button"
                    [disabled]="!this.makeCoffeeForm.controls['coffeeCode'].value">
              Make a Coffee
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col"></div>
  </div>
  <div class="row" *ngIf="isSuccess && !errorMessage">
    <div class="col">
      Thanks a lot. You wrote a cup of coffee off and can make it right now.
    </div>
  </div>
  <div class="row" *ngIf="!isSuccess && errorMessage">
    <div class="col">
      {{ errorMessage }}
    </div>
  </div>
</div>
